import { render, staticRenderFns } from "./AddCatalogueItem.vue?vue&type=template&id=49290e21&scoped=true&"
import script from "./AddCatalogueItem.vue?vue&type=script&lang=js&"
export * from "./AddCatalogueItem.vue?vue&type=script&lang=js&"
import style0 from "./AddCatalogueItem.vue?vue&type=style&index=0&id=49290e21&scoped=true&lang=scss&"
import style1 from "./AddCatalogueItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49290e21",
  null
  
)

export default component.exports